import React, { useState } from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { actUserLogout } from "../../../../actions";

import LogoutModal from "../../../common/LogoutModal";
import "./index.css";

const MobileDashboardSidepanel = (props) => {
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const { pathname } = props.location;

  const logoutSubmit = () => {
    props.actUserLogout();
  };

  const isActive = (path) =>
    pathname === path ? "mob-dashboard-active uk-text-bold" : "";

  return (
    <div id="dashboard-offcanvas-slide" data-uk-offcanvas="overlay: true">
      <div className="uk-offcanvas-bar dashboard-uk-offcanvas-bar">
        <button
          className="uk-offcanvas-close"
          type="button"
          data-uk-close
        ></button>

        <a
          className="uk-logo-mobile uk-text-left uk-scrollspy-inview"
          href="index.html"
          data-uk-scrollspy="cls: uk-animation-slide-bottom-small; delay: 200"
        >
          {window.logo.mobile_menubar_logo.map((data, i) => (
            <div key={i}>
              <img
                className="uk-align-center uk-margin-remove-bottom"
                src={`${process.env.PUBLIC_URL}` + data.image}
                alt={data.alt}
                width="180"
                height="180"
              />
            </div>
          ))}
        </a>
        <div className="heading-icon">
          <span className="sidemenubar-hr-line">&nbsp;</span>
          <span className="diamondstand-icon">&nbsp;</span>
          <span className="sidemenubar-hr-line">&nbsp;</span>
        </div>

        <div className="uk-padding-small uk-margin-top">
          <ul className="uk-list uk-list-bullet uk-list-divider">
            <div className="uk-animation-toggle" tabIndex="0">
              <Link
                to={`${process.env.PUBLIC_URL}/dashboard`}
                className={isActive("/dashboard")}
              >
                <li className="uk-display-block uk-animation-slide-right-small uk-text-bold para-one active">
                  Dashboard
                </li>
              </Link>
            </div>
            <div className="uk-animation-toggle" tabIndex="0">
              <Link
                to={`${process.env.PUBLIC_URL}/my-orders`}
                className={isActive("/my-orders")}
              >
                <li className="uk-display-block uk-animation-slide-right-small para-one">
                  My Orders
                </li>
              </Link>
            </div>
            <div className="uk-animation-toggle" tabIndex="0">
              <Link
                to={`${process.env.PUBLIC_URL}/user/profile`}
                className={isActive("/user/profile")}
              >
                <li className="uk-display-block uk-animation-slide-right-small para-one">
                  Edit Profile
                </li>
              </Link>
            </div>
            <div className="uk-animation-toggle" tabIndex="0">
              <Link
                to={`${process.env.PUBLIC_URL}/change-password`}
                className={isActive("/change-password")}
              >
                <li className="uk-display-block uk-animation-slide-right-small para-one">
                  Change Password
                </li>
              </Link>
            </div>
            <div className="uk-animation-toggle" tabIndex="0">
              <a onClick={() => setShowLogoutModal(true)}>
                <li className="uk-display-block uk-animation-slide-right-small para-one">
                  Log Out
                </li>
              </a>
            </div>
          </ul>
        </div>

        <LogoutModal
          open={showLogoutModal}
          onClose={() => setShowLogoutModal(false)}
          onLogout={logoutSubmit}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({});

export default withRouter(
  connect(mapStateToProps, { actUserLogout })(MobileDashboardSidepanel),
);
